import type { SupportedLanguage } from "../../i18n";
import Actions from "../consts";

export const setCurrentLanguage = (language: SupportedLanguage) => ({
  type: Actions.SET_CURRENT_LANGUAGE,
  payload: language,
});
